import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext } from 'react';
const TableContext = createContext({});
const TableProvider = ({ isCollapsedNav, children }) => {
    const [activeRow, setActiveRow] = React.useState(undefined);
    const value = React.useMemo(() => ({
        activeRow,
        setActiveRow,
        isCollapsedNav,
    }), [activeRow, setActiveRow, isCollapsedNav]);
    return _jsx(TableContext.Provider, { value: value, children: children });
};
const useTableContext = () => {
    const value = React.useContext(TableContext);
    if (!value) {
        throw new Error('`useTableContext` is used outside `TableContext.Provider`');
    }
    return value;
};
export { useTableContext, TableProvider };
